import React from "react";

const ViewTypeSelect = ({ value = localStorage.getItem('viewType'), onChange, permissions }) => {

  const shouldRender = (permissions?.category_wise?.display || permissions?.category_wise?.allowed)||(permissions?.product_wise?.display || permissions?.product_wise?.allowed);
  const showOverlayProduct = !(permissions?.product_wise?.display);
   const showOverlayVariation = !(permissions?.product_wise?.display);
  const showOverlayCategory = !(permissions?.category_wise?.display );
  const disabledCategory = permissions?.category_wise?.display &&  !permissions?.category_wise?.allowed
  const disabledProduct = permissions?.product_wise?.display &&  !permissions?.product_wise?.allowed

  if (!shouldRender) return null;
  
  return (
    <select
      className="form-select form-select-sm category-select"
      style={{ width: "150px" }}
      value={value || ""}
      onChange={onChange}
    >
      {!showOverlayCategory && (
        <option disabled={disabledCategory} value="category">Category </option>
      )}
      {!showOverlayProduct && (
        <option disabled={disabledProduct} value="product">Product </option>
      )}
      {!showOverlayVariation &&(
        <option disabled={disabledProduct} value="variation">Variation </option>
      )}
    </select>
  );
};

export default ViewTypeSelect;
